import {
  BR_MGMT_BACKEND_URL,
  BR_PURPOSE_BACKEND_URL,
  devEnv,
  INVESTMENT_PROFILE_BACKEND_URL,
  PARTNER_MGMT_API_URL,
  WEALTH_OVERVIEW_BACKEND_URL,
} from 'services/constants';
import axios, { AxiosError } from 'axios';
import { ToggleType } from 'types/Financials';

const axiosInstance = axios.create({ withCredentials: devEnv });

/**
 * Fetch the list of feature flags for feature toggling.
 */
const getFeatures = async () => {
  const json = await axiosInstance.get(`${PARTNER_MGMT_API_URL}/features/read`);
  return json.data;
};

const getFinancialsFeatures = async (): Promise<ToggleType[]> => {
  const response = await axiosInstance
    .get(`${WEALTH_OVERVIEW_BACKEND_URL}/api/config/flag`)
    .catch((error: AxiosError) => {
      throw error;
    });

  return response.data;
};

const getInvestmentProfileFeatures = async (): Promise<ToggleType[]> => {
  const response = await axiosInstance
    .get(`${INVESTMENT_PROFILE_BACKEND_URL}/api/config/flag`)
    .catch((error: AxiosError) => {
      throw error;
    });

  return response.data;
};

const getBrPurposeFeatures = async (): Promise<ToggleType[]> => {
  const response = await axiosInstance.get(`${BR_PURPOSE_BACKEND_URL}/api/config/flag`).catch((error: AxiosError) => {
    throw error;
  });

  return response.data;
};

export interface BrMgmtFeatures {
  domicileCoverage: boolean;
  onlyIntermediaryBr: boolean;
  approvalBtnEnabler: boolean;
  authorizedSignatoryDocReference: boolean;
  createSignatoryListBtnEnabled: boolean;
}

const getBrMgmtFeatures = async (): Promise<BrMgmtFeatures> => {
  const response = await axiosInstance.get(`${BR_MGMT_BACKEND_URL}/api/features/read`).catch((error: AxiosError) => {
    throw error;
  });

  return response.data.api;
};

export default {
  getFeatures,
  getFinancialsFeatures,
  getInvestmentProfileFeatures,
  getBrPurposeFeatures,
  getBrMgmtFeatures,
};
